<template>
  <div class="order-management-container">
    <!-- 顶部搜索和操作区域 -->
    <div class="top-section">
      <div class="search-area">
        <div class="search-item">
          <label class="label">单号</label>
          <a-input
            placeholder="波次任务/出库订单/快递单号/拣货车"
            class="search-input"
          />
        </div>

        <div class="search-item">
          <label class="label">商品编码</label>
          <a-input
            placeholder=""
            class="search-input"
          />
        </div>

        <div class="search-item">
          <label class="label">包材</label>
          <a-input
            placeholder=""
            class="search-input"
          />
          <a-checkbox class="checkbox">锁定</a-checkbox>
          <a-checkbox class="checkbox">扫描</a-checkbox>
        </div>
      </div>

      <div class="action-area">
        <div class="tags">
          <span class="tag">波次任务</span>
          <span class="tag">订单数</span>
          <span class="tag">出库订单</span>
          <span class="tag">快递单</span>
          <span class="tag">赠品</span>
        </div>

        <div class="buttons">
          <a-radio-group v-model="isClosed" class="close-radio">
            <a-radio :value="true">关闭</a-radio>
            <a-button icon="setting" class="setting-btn" />
          </a-radio-group>
          <a-button type="primary" class="print-btn print-express">
            <a-icon type="check" /> 打印快递单
          </a-button>
          <a-checkbox class="print-checkbox">打印发货单</a-checkbox>
        </div>
      </div>
    </div>

    <!-- 中间统计区域 -->
    <div class="stats-area">
      <div class="stat-item">
        <div class="stat-label">未扫描数</div>
        <div class="stat-value blue">0</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">已扫描数</div>
        <div class="stat-value green">0</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">已取消数</div>
        <div class="stat-value red">0</div>
      </div>
    </div>

    <!-- 底部表格区域 -->
    <div class="tables-area">
      <!-- 待扫描表格 -->
      <div class="table-container">
        <div class="table-title">待扫描</div>
        <a-table
          :columns="pendingColumns"
          :data-source="pendingData"
          :pagination="pagination"
          rowKey="id"
        ></a-table>
      </div>

      <!-- 已扫描表格 -->
      <div class="table-container">
        <div class="table-title">已扫描</div>
        <a-table
          :columns="scannedColumns"
          :data-source="scannedData"
          :pagination="pagination"
          rowKey="id"
        ></a-table>
      </div>
    </div>

    <!-- 底部状态栏 -->
    <div class="status-bar">
      <div class="left-status">
        <a-icon type="menu" class="menu-icon" />
        <a-icon type="setting" class="setting-icon" />
      </div>
      <div class="right-status">已连接</div>
    </div>
  </div>
</template>

<script>
import {
  Input, Checkbox, Radio, Button, Icon, Table,
  Pagination
} from 'ant-design-vue';

export default {
  components: {
    aInput: Input,
    aCheckbox: Checkbox,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    aButton: Button,
    aIcon: Icon,
    aTable: Table,
    aPagination: Pagination
  },
  data() {
    return {
      isClosed: false,
      // 待扫描表格列定义
      pendingColumns: [
        {
          title: '',
          dataIndex: 'checkbox',
          width: 40,
          render: () => <a-checkbox />
        },
        {
          title: '出库订单',
          dataIndex: 'orderNo',
          key: 'orderNo',
        },
        {
          title: '是否取消',
          dataIndex: 'isCancelled',
          key: 'isCancelled',
        },
        {
          title: '商品',
          dataIndex: 'productCode',
          key: 'productCode',
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          key: 'productName',
        },
        {
          title: '颜色',
          dataIndex: 'color',
          key: 'color',
        },
        {
          title: '商品规格',
          dataIndex: 'spec',
          key: 'spec',
        }
      ],
      // 已扫描表格列定义
      scannedColumns: [
        {
          title: '',
          dataIndex: 'checkbox',
          width: 40,
          render: () => <a-checkbox />
        },
        {
          title: '出库订单',
          dataIndex: 'orderNo',
          key: 'orderNo',
        },
        {
          title: '是否取消',
          dataIndex: 'isCancelled',
          key: 'isCancelled',
        },
        {
          title: '商品',
          dataIndex: 'productCode',
          key: 'productCode',
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          key: 'productName',
        },
        {
          title: '颜色',
          dataIndex: 'color',
          key: 'color',
        },
        {
          title: '商品规格',
          dataIndex: 'spec',
          key: 'spec',
        }
      ],
      // 表格数据 - 空数据
      pendingData: [],
      scannedData: [],
      // 分页配置
      pagination: {
        pageSize: 20,
        showSizeChanger: false,
        showTotal: (total) => `显示0到0,共0条记录`,
        current: 1,
        total: 0,
        showQuickJumper: false
      }
    };
  }
};
</script>

<style scoped>
.order-management-container {
  padding: 16px;
  background-color: #fff;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.top-section {
  display: flex;
  margin-bottom: 20px;
  gap: 20px;
}

.search-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.label {
  width: 80px;
  text-align: right;
  font-weight: 500;
}

.search-input {
  width: 300px;
}

.checkbox {
  margin-left: 12px;
}

.action-area {
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tags {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tag {
  color: #666;
  padding: 4px 0;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
}

.close-radio {
  align-self: flex-start;
  margin-bottom: 8px;
}

.setting-btn {
  background: transparent;
  border: none;
  color: #666;
  align-self: flex-end;
}

.print-btn {
  width: 140px;
}

.print-express {
  background-color: #722ed1;
  border-color: #722ed1;
}

.print-express:hover {
  background-color: #8341e8;
  border-color: #8341e8;
}

.print-checkbox {
  align-self: flex-end;
  margin-top: 4px;
}

.stats-area {
  display: flex;
  justify-content: flex-end;
  gap: 40px;
  margin-bottom: 20px;
  padding-right: 40px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-label {
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
}

.blue {
  color: #1890ff;
}

.green {
  color: #52c41a;
}

.red {
  color: #f5222d;
}

.tables-area {
  display: flex;
  gap: 20px;
  flex: 1;
  overflow: hidden;
}

.table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.table-title {
  padding: 8px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 500;
}

.ant-table {
  flex: 1;
  overflow: auto;
}

.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-top: 1px solid #e8e8e8;
  margin-top: 16px;
}

.left-status {
  display: flex;
  gap: 16px;
}

.menu-icon, .setting-icon {
  cursor: pointer;
  color: #666;
}

.right-status {
  color: #52c41a;
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
